import React, {
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import { useLocation, useNavigate } from "react-router";
import toast from "react-hot-toast";
import axios from "axios";
import TableComponent from "../../Components/CommonComponent/Table/Table";
import SaveButton from "../../Components/CommonComponent/Button/SaveButton";
import CancelButton from "../../Components/CommonComponent/Button/CancelButton";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { CommonContext } from "../../App";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import ContactMarquee from "../../Components/CommonComponent/Table/ContactMarquee";
import api from "../../services/api";
import LoadingSpinner from "../../Components/CommonComponent/loadingSpiner/LoadingSpinner";
import DeleteDataModal from "../../Components/CommonComponent/Modals/DeleteDataModal";
import { getGlobalExpenseFilters } from "../../Components/CommonComponent/Modals/ShowTableFilterModal";

export default function PurchaseTable({
  isModal = false,
  updatedDate,
  onModalClose,
  onModalSuccess,
  entry: modalEntry,
}) {
  const { t } = useTranslation();
  const heading = t("purchase");

  const navigate = useNavigate();
  const location = useLocation();
  const { entry: locationEntry, comeBack } = location.state || {};
  const entry = isModal ? modalEntry : locationEntry;

  const {
    userData,
    branchId,
    setTotalPurchase,
    setPurchasewithItem,
    dateRange,
  } = useContext(CommonContext);

  const adminId = userData?.user?.id;
  const userRole = userData?.user?.role;
  const isInitialLoadRef = useRef(true);
  const isSettingDataRef = useRef(false);
  const [salesData, setSalesData] = useState([]);
  const [transportationData, setTransportationData] = useState([]);
  const [loadingData, setLoadingData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [editingEntry, setEditingEntry] = useState(null);
  const [editingEntryKey, setEditingEntryKey] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const LIMIT = 15;
  const [totalRecoard, setTotalRecoard] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [allLedgers, setAllLedgers] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [transportationLedgerData, setTransportationLedgerData] = useState([]);
  const [loadingLedgerData, setLoadingLedgerData] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [allSubGroups, setAllSubGroups] = useState([]);
  const [allPaymentData, setAllPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [lockedSalesFields, setLockedSalesFields] = useState({
    vendor: "",
    address: "",
    phone: "",
    ledgerId: "",
    ledgerGroup: "",
    ledgerSubGroup: "",
  });

  const [currentSalesItem, setCurrentSalesItem] = useState({
    items: "",
    quantity: "",
    unit: "",
    perQuantity: "",
  });

  const [tableFilterModalOpen, setTableFilterModalOpen] = useState(false);

  const [tableFilters, setTableFilters] = useState(() => {
  const g = getGlobalExpenseFilters();
  return { transportation: g.purchaseTransportation, loadingUnloading: g.purchaseLoading };
});

  const [endDate, setEndDate] = useState(dateRange.endDate);

  
  useEffect(() => {
    const timer = setTimeout(() => {
      const firstInput = document.querySelector('input[type="text"]');
      if (firstInput) firstInput.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    setEndDate(dateRange.endDate);
  }, [dateRange.endDate]);

useEffect(() => {
  const handler = () => {
    const g = getGlobalExpenseFilters();
    setTableFilters({ transportation: g.purchaseTransportation, loadingUnloading: g.purchaseLoading });
  };
  window.addEventListener("global_expense_filters_updated", handler);
  return () => window.removeEventListener("global_expense_filters_updated", handler);
}, []);



  const fetchGroups = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(
        `groups-types/get-all-group?branchId=${branchId}`
      );
      if (res.data.success) setAllGroups(res.data.allData || []);
    } catch {
      toast.error("Failed to fetch groups");
    }
  }, [branchId]);

  const fetchSubGroups = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(
        `groups-types/get-all-sub-group?branchId=${branchId}`
      );
      if (res.data.success) setAllSubGroups(res.data.allData || []);
    } catch {
      toast.error("Failed to fetch subgroups");
    }
  }, [branchId]);

  const fetchLedgerData = useCallback(async () => {
    if (!branchId) return;
    try {
      setLoading(true);
      const res = await api.get(
        `ledgers/get-all-ledger?branchId=${branchId}&isActive=1`
      );
      if (res.data.success) {
        setAllLedgers(res.data.allData || []);
        setLedgerData(res.data.allData || []);
        setTransportationLedgerData(res.data.allData || []);
        setLoadingLedgerData(res.data.allData || []);
      }
    } catch (err) {
      toast.error(err.message || "Failed to fetch ledgers");
    } finally {
      setLoading(false);
    }
  }, [branchId, fetchGroups, fetchSubGroups]);

  const fetchPaymentAccount = useCallback(async () => {
    if (!branchId) return;
    try {
      setLoading(true);
      const res = await api.get(
        `payment-structure/get-all-data?branchId=${branchId}`
      );
      if (res.data.success) {
        setAllPaymentData(res.data.data || []);
      }
    } catch (err) {
      toast.error(err.message || "Failed to fetch payment accounts");
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    if (!branchId) return;

    const loadMetaData = async () => {
      setLoading(true);

      await Promise.all([
        fetchLedgerData(),
        fetchPaymentAccount(),
        fetchGroups(),
        fetchSubGroups(),
      ]);

      setLoading(false);
    };

    loadMetaData();
  }, [branchId]);


  useEffect(() => {
    if (!entry) return;

    isInitialLoadRef.current = true;
    isSettingDataRef.current = true;

    setEditingEntry(entry);
    if(isModal){
      setIsEditMode(true);
    }
    setEditingEntryKey(entry.purchaseKey || entry._key);

    setSalesData(entry.purchases || []);
    setTransportationData(entry.transportation || []);
    setLoadingData(entry.loading || []);

    if (entry.purchases?.length > 0) {
      setLockedSalesFields({
        vendor: entry.purchases[0].vendor || "",
        address: entry.purchases[0].address || "",
        phone: entry.purchases[0].phone || "",
        ledgerId: entry.purchases[0].ledgerId || "",
        ledgerGroup: entry.purchases[0].ledgerGroup || "",
        ledgerSubGroup: entry.purchases[0].ledgerSubGroup || "",
      });
    }

    setResetKey((prev) => prev + 1);

    setTimeout(() => {
      isSettingDataRef.current = false;

      if (entry.purchases?.length > 0) {
        const firstPurchase = entry.purchases[0];
        const totalQty = entry.purchases.reduce(
          (sum, row) => sum + (parseFloat(row.quantity) || 0),
          0
        );

        setTransportationData((prev) =>
          prev.map((row, idx) =>
            idx === 0
              ? {
                  ...row,
                  items: firstPurchase.items || row.items || "",
                  quantity: totalQty.toString(),
                  unit: firstPurchase.unit || row.unit || "",
                  perQuantity:
                    firstPurchase.per_quantity ||
                    firstPurchase.perQuantity ||
                    row.per_quantity ||
                    "",
                }
              : row
          )
        );

        setLoadingData((prev) =>
          prev.map((row, idx) =>
            idx === 0
              ? {
                  ...row,
                  items: firstPurchase.items || row.items || "",
                  quantity: totalQty.toString(),
                  unit: firstPurchase.unit || row.unit || "",
                  perQuantity:
                    firstPurchase.per_quantity ||
                    firstPurchase.perQuantity ||
                    row.per_quantity ||
                    "",
                }
              : row
          )
        );
      }
    }, 300);
  }, [entry]);

const handleSalesDataChange = useCallback(
  (data) => {
    setSalesData(data);

    if (!data || data.length === 0) return;

    const firstRow = data[0];
    
    //  Calculate total quantity excluding deleted rows
    const totalQuantity = data
      .filter(row => row.frontendDelete !== 0)
      .reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);

    const unit =
      firstRow?.typeOfBricks?.unit ||
      firstRow?.items?.unit ||
      firstRow.unit ||
      "";

    const perQuantity =
      firstRow?.typeOfBricks?.perQuantity ||
      firstRow?.items?.perQuantity ||
      firstRow.perQuantity ||
      firstRow.per_quantity ||
      "";

    setCurrentSalesItem({
      items: firstRow.items || firstRow.typeOfBricks || "",
      quantity: totalQuantity.toString(),
      unit: unit || "",
      perQuantity: perQuantity || "",
    });

    const newLockedFields = {
      vendor: firstRow.vendor || "",
      address: firstRow.address || "",
      phone: firstRow.phone || "",
      ledgerId: firstRow.ledgerId || "",
      ledgerGroup: firstRow.ledgerGroup || "",
      ledgerSubGroup: firstRow.ledgerSubGroup || "",
    };

    setLockedSalesFields((prev) =>
      JSON.stringify(prev) === JSON.stringify(newLockedFields)
        ? prev
        : newLockedFields
    );

    if (isSettingDataRef.current) return;

    const isInitialLoad = isInitialLoadRef.current;
    if (isInitialLoad) isInitialLoadRef.current = false;

    //  CRITICAL FIX: Always sync transportation and loading when data changes
    const syncWithSales = (prevData) => {
      if (!prevData || prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        // Skip deleted rows
        if (row.frontendDelete === 0) return row;
        
        return {
          ...row,
          items: firstRow.items || row.items || "",
          unit: unit || row.unit || "",
          perQuantity: perQuantity || row.perQuantity || row.per_quantity || "",
          quantity: idx === 0 ? totalQuantity.toString() : '0',
        };
      });
    };

    setTransportationData((prev) => syncWithSales(prev));
    setLoadingData((prev) => syncWithSales(prev));
  },
  [isEditMode]
);

  const handleTransportationDataChange = useCallback((data) => {
    setTransportationData(data);
  }, []);

  const handleItemChange = useCallback((item, quantity, unit, unitId, itemInOut, rate, total, perQuantity) => {
    // Calculate total quantity excluding deleted rows
    const totalQty = salesData
      .filter(row => row.frontendDelete !== 0)
      .reduce((sum, row) => {
        const qty = parseFloat(row.quantity) || 0;
        return sum + qty;
      }, 0);

    setCurrentSalesItem({
      items: item,
      quantity: totalQty.toString(),
      unit: item?.unit || unit || '',
      perQuantity: item?.perQuantity || perQuantity || '',
    });

    // Update transportation table - in edit mode, only update quantity
    setTransportationData((prevData) => {
      if (prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row;
        if (idx === 0) {
          // In edit mode, only update quantity, keep other fields
          if (isEditMode) {
            return {
              ...row,
              quantity: totalQty.toString(),
            };
          }
          // In create mode, update all fields
          return {
            ...row,
            items: item,
            quantity: totalQty.toString(),
            unit: item?.unit || unit || '',
            perQuantity: item?.perQuantity || perQuantity || '',
          };
        }
        // For other rows, set quantity to 0
        return {
          ...row,
          quantity: '0',
        };
      });
    });

    // Update loading table - in edit mode, only update quantity
    setLoadingData((prevData) => {
      if (prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row;
        if (idx === 0) {
          // In edit mode, only update quantity, keep other fields
          if (isEditMode) {
            return {
              ...row,
              quantity: totalQty.toString(),
            };
          }
          // In create mode, update all fields
          return {
            ...row,
            items: item,
            quantity: totalQty.toString(),
            unit: item?.unit || unit || '',
            perQuantity: item?.perQuantity || perQuantity || '',
          };
        }
        // For other rows, set quantity to 0
        return {
          ...row,
          quantity: '0',
        };
      });
    });
  }, [salesData, isEditMode]);

  const handleLoadingDataChange = useCallback((data) => {
    setLoadingData(data);
  }, []);

  
  const fetchRealData = useCallback(
    async (pageNum = 1, reset = false) => {
      if (!branchId || !endDate) return;
      try {
        if (pageNum === 1) setLoading(true);
        else setLoadingMore(true);

        const res = await api.get(
          `purchase/get-purchase-entry?branchId=${branchId}&date=${endDate}&page=${pageNum}&limit=${LIMIT}&order=desc`
        );

        if (res.data.success) {
          setTotalRecoard(res.data.total);
          const newData = res.data.entries || [];
          setGroupedData((prev) => (reset ? newData : [...prev, ...newData]));
          setHasMore(newData.length === LIMIT);
        }
      } catch (error) {
        toast.error("Failed to load consolidated data.");
        console.error(error);
      } finally {
        setLoadingMore(false);
        setLoading(false);
      }
    },
    [branchId, endDate]
  );


  const fetchFinalData = useCallback(async () => {
    if (!branchId) return;
    try {
      setLoading(true);
      const res = await api.get(
        `purchase/get-all-purchase?branchId=${branchId}`
      );
      if (res.data.success) {
        setFinalData(res.data.entries || []);
        setTotalPurchase(res.data.totalQuantity || 0);
        setPurchasewithItem(res.data.quantityByItems || []);
      }
    } catch (error) {
      toast.error("Failed to load consolidated data.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [branchId, setTotalPurchase, setPurchasewithItem]);

  useEffect(() => {
    if (branchId && endDate) {
      setPage(1);
      setHasMore(true);
      fetchRealData(1, true);
    }
  }, [branchId, endDate, fetchRealData]);

  useEffect(() => {
    if (branchId) fetchFinalData();
  }, [branchId, fetchFinalData]);

  const refreshTable = useCallback(() => {
    setPage(1);
    setHasMore(true);
    fetchRealData(1, true);
  }, [fetchRealData]);


  const purchaseColumns = useMemo(
    () => [
      {  header: t("vendor"), placeholder: "vendor", inputType: "input", active: true,
        filteration: true, locked: true, combined: true,type: 'text',uniqueId:"#vendor"},
      { header: t("address"), placeholder: "address", inputType: "input", active: true, combined: true,type: 'text' ,uniqueId:"#address"},
      { header: t("phone"), placeholder: "phone", inputType: "input", active: true, combined: true,type: 'text',uniqueId:"#phone" },
      {  header: t("purchaseItems"), placeholder: "items", inputType: "dropdown", options: [], active: true, filteration: true,type: 'text',uniqueId:"#purchaseItems",columnPart: "Stock" },
      { header: t("quantity"), placeholder: "quantity", inputType: "input", active: true,showUnit: true,type: 'number',uniqueId:"#quantity" },
      { header: t("unit"), placeholder: "unit", inputType: "input", active: false,type: 'text',uniqueId:"#unit" },
      { header: t("rate"), placeholder: "rate", inputType: "input", active: true ,type: 'number',uniqueId:"#rate"},
      {header: t("total"), placeholder: "total",inputType: "input", active: true,readOnly: false, type: 'number',uniqueId:"#total" },
      { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text' ,uniqueId:"#description"},
      { header: t("paymentType"), placeholder: "paymentType", inputType: "dropdown", options: [], active: true,
        addDropDownOptions: true, type: 'text',uniqueId:"#paymentType" },
      { header: t("paid"), placeholder: "paid", inputType: "input", active: true,type: 'number',uniqueId:"#paid" },
      isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
    ],
    [t,isEditMode]
  );
  
 const transportationColumns = useMemo(() => ([
    { header: t('name'), placeholder: 'name', inputType: 'input', active: true, filteration: true, combined: true, type: 'text',uniqueId:"#name" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#address" },
    { header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#phone" },
    { header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number' ,uniqueId:"#quantity"},
    { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text' ,uniqueId:"#unit"},
    { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number' ,uniqueId:"#rate"},
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number',uniqueId:"#total" },
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text' ,uniqueId:"#description"},
    { header: t('paymentType'), placeholder: 'paymentType', inputType: 'dropdown', options: [], active: true, addDropDownOptions: true, type: 'text' ,uniqueId:"#paymentType"},
    { header: t('paid'), placeholder: 'paid', inputType: 'input', active: true, type: 'number',uniqueId:"#paid" },
    { header: t('part'), placeholder: 'part', inputType: 'input', status: 'auto', defaultValue: 'sales', active: true, type: 'text',uniqueId:"#part" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const loadingColumns = useMemo(() => ([
    { header: t('name'), placeholder: 'name', inputType: 'input', active: true, filteration: true, combined: true, type: 'text',uniqueId:"#name" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#address" },
    { header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, combined: true, type: 'text' ,uniqueId:"#phone"},
    { header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number',uniqueId:"#quantity" },
    { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text',uniqueId:"#unit" },
    { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number' ,uniqueId:"#rate"},
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number' ,uniqueId:"#total"},
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text',uniqueId:"#description" },
    { header: t('paymentType'), placeholder: 'paymentType', inputType: 'dropdown', options: [], active: true, addDropDownOptions: true, type: 'text',uniqueId:"#paymentType" },
    { header: t('paid'), placeholder: 'paid', inputType: 'input', active: true, type: 'number' ,uniqueId:"#paid"},
    { header: t('part'), placeholder: 'part', inputType: 'input', status: 'auto', defaultValue: 'sales', active: true, type: 'text',uniqueId:"#part" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const visibleSalesColumns = purchaseColumns.filter(
    (c) => c.active && c.status !== "auto"
  );
  const visibleTransportationColumns = transportationColumns.filter(
    (c) => c.active && c.status !== "auto"
  );
  const visibleLoadingColumns = loadingColumns.filter(  
    (c) => c.active && c.status !== "auto"
  );


  const addAutoFields = useCallback((data, columns) => {
    const autoCols = columns.filter((col) => col.status === "auto");
    return data.map((row) => {
      const updated = { ...row };
      autoCols.forEach((col) => {
        updated[col.placeholder] = col.defaultValue;
      });
      return updated;
    });
  }, []);


  const ledgerGroupMappingSales = {
    customerName: "Current Liabilities",
    items: "Raw Material",
    paymentType: "Current Assets",
  };

  const ledgerGroupMappingTransporte = {
    customerName: "Vehicle",
    items: "Raw Material ",
    paymentType: "Current Assets",
  };

  const ledgerGroupMappingLoading = {
    customerName: "Labour",
    items: "Raw Material ",
    paymentType: "Current Assets",
  };

  const allSavedSalesRows = useMemo(
    () => finalData.flatMap((entry) => entry.purchase || []),
    [finalData]
  );

  const allSavedloadingRows = useMemo(
    () => finalData.flatMap((entry) => entry.loading || []),
    [finalData]
  );

  const allSavedTransporteRows = useMemo(
    () => finalData.flatMap((entry) => entry.transportation || []),
    [finalData]
  );

  const handleSave = useCallback(async () => {
    const purchaseKey = isEditMode ? editingEntryKey : uuidv4();
    setIsSaving(true);

    try {
      // Include ALL rows, even deleted ones (with frontendDelete marker)
      const salesWithAuto = addAutoFields(salesData, purchaseColumns).map(
        (item) => ({
          ...item,
          vendor: lockedSalesFields.vendor,
          address: lockedSalesFields.address,
          phone: lockedSalesFields.phone,
          ledgerId: item.ledgerId || lockedSalesFields.ledgerId,
          ledgerGroup: item.ledgerGroup || lockedSalesFields.ledgerGroup,
          ledgerSubGroup: item.ledgerSubGroup || lockedSalesFields.ledgerSubGroup,
          purchase_key: purchaseKey,
          branchId,
          ...(item.frontendDelete === 0 && { frontendDelete: 0 }), // Include frontendDelete marker
        })
      );

      const transWithAuto = addAutoFields(
        transportationData,
        transportationColumns
      ).map((item) => ({
        ...item,
        purchase_key: purchaseKey,
        branchId,
        per_quantity:
          item.perQuantity ||
          item.per_quantity ||
          currentSalesItem.perQuantity ||
          "",
        unit: item.unit || currentSalesItem.unit || "",
        ...(item.frontendDelete === 0 && { frontendDelete: 0 }),
      }));

      const loadWithAuto = addAutoFields(loadingData, loadingColumns).map(
        (item) => ({
          ...item,
          purchase_key: purchaseKey,
          branchId,
          per_quantity:
            item.perQuantity ||
            item.per_quantity ||
            currentSalesItem.perQuantity ||
            "",
          unit: item.unit || currentSalesItem.unit || "",
          ...(item.frontendDelete === 0 && { frontendDelete: 0 }),
        })
      );

      if (isEditMode) {
        const payload = {
          entryDate: updatedDate || endDate,
          purchaseKey,
          sales: salesWithAuto,
          transportation: transWithAuto,
          loading: loadWithAuto,
          branchId,
          adminId,
        };

        const updateRes = await api.post(
          `purchase/update-purchase-entry`,
          payload
        );

        if (updateRes.data.success) {
          if (updateRes.data.data) {
            setFinalData((prev) =>
              prev.map((entry) =>
                entry.purchase_key === purchaseKey
                  ? { ...entry, ...updateRes.data.data }
                  : entry
              )
            );
            setGroupedData((prev) =>
              prev.map((entry) =>
                entry.purchase_key === purchaseKey
                  ? { ...entry, ...updateRes.data.data }
                  : entry
              )
            );
          }

          toast.success("Data updated successfully!");
          fetchFinalData();
          refreshTable();

          if (isModal && onModalSuccess) {
            onModalSuccess();
          } else if (comeBack) {
            navigate(comeBack, {
              state: { entry: updateRes.data.data.purchase[0] },
            });
          }
        }
      } else {
        const payload = {
          entryDate: endDate,
          purchaseKey,
          purchase: salesWithAuto,
          transportation: transWithAuto,
          loading: loadWithAuto,
          branchId,
        };

        const createRes = await api.post(
          `purchase/create-purchase-entry`,
          payload
        );

        if (createRes.data.success) {
          toast.success("Data saved successfully!");
          fetchFinalData();
          refreshTable();

          if (isModal && onModalSuccess) {
            onModalSuccess();
          } else if (comeBack) {
            navigate(comeBack, { state: { entry } });
          }
        }
      }

      if (isEditMode) {
        await handleCancelEdit();
      } else {
        setResetKey((prev) => prev + 1);
        setLockedSalesFields({
          vendor: "",
          address: "",
          phone: "",
          ledgerId: "",
          ledgerGroup: "",
          ledgerSubGroup: "",
        });
      }

      setTimeout(() => {
        const firstInput = document.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
      }, 100);
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to save data.";
      toast.error(backendMessage);
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  }, [
    isEditMode,
    editingEntryKey,
    addAutoFields,
    salesData,
    purchaseColumns,
    transportationData,
    transportationColumns,
    loadingData,
    loadingColumns,
    lockedSalesFields,
    branchId,
    adminId,
    updatedDate,
    endDate,
    isModal,
    onModalSuccess,
    comeBack,
    navigate,
    entry,
    fetchFinalData,
    refreshTable,
    currentSalesItem,
  ]);
  
  useEffect(() => {
    if (page > 1) {
      fetchRealData(page);
    }
  }, [page, fetchRealData]);


  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 20 && hasMore && !loadingMore) {
      setPage(prev => prev + 1);
    }
  };


  const handleEditEntry = useCallback((entry) => {
    isInitialLoadRef.current = true;
    isSettingDataRef.current = true;

    setEditingEntry(entry);
    setIsEditMode(true);
    setEditingEntryKey(entry.purchaseKey);

    setSalesData(entry.purchases?.reverse() || []);
    setTransportationData(entry.transportation?.reverse() || []);
    setLoadingData(entry.loading?.reverse() || []);

    if (entry.purchases?.length > 0) {
      setLockedSalesFields({
        vendor: entry.purchases[0].vendor || "",
        address: entry.purchases[0].address || "",
        phone: entry.purchases[0].phone || "",
        ledgerId: entry.purchases[0].ledgerId || "",
        ledgerGroup: entry.purchases[0].ledgerGroup || "",
        ledgerSubGroup: entry.purchases[0].ledgerSubGroup || "",
      });
    }

    setResetKey((prev) => prev + 1);

    setTimeout(() => {
      isSettingDataRef.current = false;
    }, 200);
  }, []);

  const handleCancelEdit = useCallback(() => {
    return new Promise((resolve) => {
      setEditingEntry(null);
      setIsEditMode(false);
      setEditingEntryKey(null);
      setSalesData([]);
      setTransportationData([]);
      setLoadingData([]);
      setLockedSalesFields({
        vendor: "",
        address: "",
        phone: "",
        ledgerId: "",
        ledgerGroup: "",
        ledgerSubGroup: "",
      });
      setResetKey((prev) => prev + 1);

      isInitialLoadRef.current = true;
      isSettingDataRef.current = false;

      if (isModal && onModalClose) {
        onModalClose();
      } else if (comeBack) {
        navigate(comeBack, { state: { entry } });
      }

      setTimeout(() => {
        const firstInput = document.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
        resolve();
      }, 0);
    });
  }, [isModal, onModalClose, comeBack, navigate, entry]);

  const handleDeletePurchaseApi = async (entry) => {
    try {
      const res = await api.post("purchase/delete-purchase-entry", {
        purchaseKey: entry.purchaseKey,
        branchId,
        adminId,
        role: userRole,
        deleteReason: entry.deleteReason,
        deletePassword: entry.deletePassword,
        entry,
      });

      if (res.data.success) {
        toast.success("Purchase entry deleted successfully");
        setShowDeleteModal(false);
        setSelectedPurchase(null);
        refreshTable();
        fetchFinalData();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed");
    }
  };

  const hasPurchase = groupedData.some((entry) => entry.purchases?.length > 0);
  const hasTransportation = groupedData.some(
    (entry) => entry.transportation?.length > 0
  );
  const hasLoading = groupedData.some((entry) => entry.loading?.length > 0);

  const showPurchase = hasPurchase;
  const showTransportation = hasTransportation;
  const showLoading = hasLoading;

  return (
    <div className="text-center">
      <div className="w-full">
        <div className="w-full">
          <div className="pt-2">
            <TableComponent
              columns={visibleSalesColumns}
              onUpdateData={fetchLedgerData}
              allLedgers={allLedgers}
              allPaymentData={allPaymentData}
              updatePaymentAccount={fetchPaymentAccount}
              setAllLedgers={setAllLedgers}
              ledgerData={ledgerData}
              setLedgerData={setLedgerData}
              allGroups={allGroups}
              allSubGroups={allSubGroups}
              setAllGroups={setAllGroups}
              setAllSubGroups={setAllSubGroups}
              heading={t("purchase")}
                tableUniqueId='#purchase_table'
              tableFilteration={true}
              uniqueForFilter="purchaseData_purchase"
              onDataChange={handleSalesDataChange}
              resetTrigger={resetKey}
              allowMultiple={true}
              suggestionsData={allSavedSalesRows}
              firstInputPlaceholder="vendor"
              finalData={finalData}
              calculateTotal={true}
              perQuantityRate="1"
              field="vendor"
              changeDesignHeading={false}
              defaultLedgerGroup="Current Liabilities"
              columnLedgerGroups={ledgerGroupMappingSales}
              lockedFields={lockedSalesFields}
              isMasterTable={true}
              tableFilterModalOpen={tableFilterModalOpen}
              setTableFilterModalOpen={setTableFilterModalOpen}
              tableFilters={tableFilters}
              setTableFilters={setTableFilters}
              syncedUnit={currentSalesItem.unit}
              createDyanamicAccount={false}
              isSettingDataRef={isSettingDataRef}
              isEditMode={isEditMode}
              showValidationError={(message) => toast.error(message)}
                    skipItemValidation={true} 

              onFilterUpdate={() => {
                setTransportationLedgerData([...ledgerData]);
                setLoadingLedgerData([...ledgerData]);
              }}
              onItemChange={handleItemChange}
              onLastInputEnter={() => {
                setTimeout(() => {
                  const buttons = document.querySelectorAll("button");
                  const saveBtn = Array.from(buttons).find((btn) =>
                    btn.textContent.toLowerCase().includes("save")
                  );
                  if (saveBtn) saveBtn.focus();
                }, 100);
              }}
              {...(editingEntry ? { initialData: editingEntry.purchases } : {})}
            />
          </div>

          {tableFilters.transportation && (
            <div className="pt-1">
              <TableComponent
                columns={visibleTransportationColumns}
                onUpdateData={fetchLedgerData}
                allLedgers={allLedgers}
                allPaymentData={allPaymentData}
                updatePaymentAccount={fetchPaymentAccount}
                setAllLedgers={setAllLedgers}
                ledgerData={ledgerData}
                setLedgerData={setLedgerData}
                allGroups={allGroups}
                allSubGroups={allSubGroups}
                setAllGroups={setAllGroups}
                setAllSubGroups={setAllSubGroups}
                heading={t("transportation")}
                  tableUniqueId='#purchase_transportation_table'
                tableFilteration={false}
                uniqueForFilter="purchaseData_transportation"
                onDataChange={handleTransportationDataChange}
                resetTrigger={resetKey}
                allowMultiple={true}
                calculateTotal={true}
                perQuantityRate="1"
                part="purchase"
                suggestionsData={allSavedTransporteRows}
                finalData={finalData}
                firstInputPlaceholder="name"
                field="name"
                changeDesignHeading={false}
                syncedItem={currentSalesItem.items}
                syncedQuantity={currentSalesItem.quantity}
                syncedUnit={currentSalesItem.unit}
                syncedPerQuantity={currentSalesItem.perQuantity}
                defaultLedgerGroup="Vehicle"
                columnLedgerGroups={ledgerGroupMappingTransporte}
                createDyanamicAccount={false}
                isSettingDataRef={isSettingDataRef}
                isEditMode={isEditMode}
                showValidationError={(message) => toast.error(message)}
                      skipItemValidation={true} 

                {...(editingEntry
                  ? { initialData: editingEntry.transportation }
                  : {})}
              />
            </div>
          )}

          {tableFilters.loadingUnloading && (
            <div className="pt-1">
              <TableComponent
                columns={visibleLoadingColumns}
                onUpdateData={fetchLedgerData}
                allLedgers={allLedgers}
                allPaymentData={allPaymentData}
                updatePaymentAccount={fetchPaymentAccount}
                setAllLedgers={setAllLedgers}
                ledgerData={ledgerData}
                setLedgerData={setLedgerData}
                allGroups={allGroups}
                allSubGroups={allSubGroups}
                setAllGroups={setAllGroups}
                setAllSubGroups={setAllSubGroups}
                heading={t("loading/unloading")}
                  tableUniqueId='#purchase_loading_table'
                tableFilteration={false}
                uniqueForFilter="purchaseData_loading"
                onDataChange={handleLoadingDataChange}
                resetTrigger={resetKey}
                allowMultiple={true}
                calculateTotal={true}
                perQuantityRate="1"
                part="purchase"
                suggestionsData={allSavedloadingRows}
                firstInputPlaceholder="name"
                finalData={finalData}
                field="name"
                changeDesignHeading={false}
                syncedItem={currentSalesItem.items}
                syncedQuantity={currentSalesItem.quantity}
                syncedUnit={currentSalesItem.unit}
                syncedPerQuantity={currentSalesItem.perQuantity}
                defaultLedgerGroup="Labours"
                columnLedgerGroups={ledgerGroupMappingLoading}
                createDyanamicAccount={false}
                isSettingDataRef={isSettingDataRef}
                isEditMode={isEditMode}
                showValidationError={(message) => toast.error(message)}
                      skipItemValidation={true} 
                {...(editingEntry ? { initialData: editingEntry.loading } : {})}
              />
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 mt-2">
          <CancelButton onClick={handleCancelEdit} text={t("cancel")} />
          <SaveButton
            onClick={(e) => {
              if (e.type === "click" || (e.type === "keydown" && e.key === "Enter")) {
                handleSave();
              }
            }}
            text={isSaving ? t("processing") : t("save")}
            disabled={isSaving}
            className="save-button"
          />
        </div>

        {loading && (
          <div className="flex justify-center items-center w-full py-10">
            <div className="flex justify-center my-4">
              <LoadingSpinner size={70} color="#be8024" />
            </div>
          </div>
        )}

        {!loading && !isModal && !onModalClose &&
          (groupedData.length > 0 ? (
            <div>
              <div
                className="overflow-x-auto lg:overflow-visible mt-2 max-h-[70vh] overflow-y-auto relative custom-scrollbar"
                onScroll={handleScroll}
              >
                <table className="w-full table-fixed border-collapse">
                  <thead className="sticky top-0 z-20 bg-theme-headerBg">
                    <tr className="bg-theme-headerBg text-theme-color">
                      <th
                        colSpan={showTransportation || showLoading ? "4" : "5"}
                        className="border-e py-[2px] text-center font-medium text-sm"
                      >
                        {t("purchase")}
                      </th>
                      {showTransportation && (
                        <th
                          colSpan={showTransportation && !showLoading ? "4" : "3"}
                          className="border-e py-[2px] text-center font-medium text-sm"
                        >
                          {t("transportation")}
                        </th>
                      )}
                      {showLoading && (
                        <th
                          colSpan={4}
                          className="py-[2px] text-center font-medium text-sm"
                        >
                          {t("loading/unloading")}
                        </th>
                      )}
                    </tr>
                    <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg">
                      <th className="border-e border-b px-1 text-center font-medium text-sm">
                        {t("srNumber")}
                      </th>
                      <th className="border-b px-1 text-start font-medium text-sm w-32">
                        {t("vendorInfo")}
                      </th>
                      <th className="border-b px-1 text-center font-medium text-sm">
                        {t("qty")} {t("unit")} {t("item")} @ {t("rate")}{" "}
                        {t("perQty")} = {t("total")}
                      </th>
                      <th className="border-b border-e px-1 text-center font-medium text-sm">
                        {t("paid")} ({t("paymentType")})
                      </th>
                      {showTransportation && (
                        <>
                          <th className="border-b px-1 text-start font-medium text-sm w-32">
                            {t("vehicle")}
                          </th>
                          <th className="border-b px-1 text-center font-medium text-sm">
                            {t("qty")} {t("unit")} {t("item")} @ {t("rate")}{" "}
                            {t("perQty")} = {t("total")}
                          </th>
                          <th className="border-b border-e px-1 text-center font-medium text-sm">
                            {t("paid")} ({t("paymentType")})
                          </th>
                        </>
                      )}
                      {showLoading && (
                        <>
                          <th className="border-b px-1 text-start font-medium text-sm w-32">
                            {t("name")}
                          </th>
                          <th className="border-b px-1 text-center font-medium text-sm">
                            {t("qty")} {t("unit")} {t("item")} @ {t("rate")}{" "}
                            {t("perQty")} = {t("total")}
                          </th>
                          <th className="border-b border-e px-1 text-center font-medium text-sm">
                            {t("paid")} ({t("paymentType")})
                          </th>
                        </>
                      )}
                      <th className="border-b px-1 text-center font-medium text-sm">
                        {t("actions")}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {groupedData.map((entry, idx) => {
                      const maxRows = Math.max(
                        entry.purchases?.length || 1,
                        entry.transportation?.length || 1,
                        entry.loading?.length || 1
                      );

                      return [...Array(maxRows)].map((_, rowIndex) => {
                        const sale = entry.purchases?.[rowIndex];
                        const transport = entry.transportation?.[rowIndex];
                        const load = entry.loading?.[rowIndex];

                        return (
                          <tr
                            key={`${entry.purchaseKey}-${rowIndex}`}
                            className="bg-theme-tableBg"
                          >
                            {rowIndex === 0 && (
                              <td
                                rowSpan={maxRows}
                                className="border-b border-e text-center font-bold align-middle text-sm"
                              >
                                {totalRecoard - idx}
                              </td>
                            )}

                            {rowIndex === 0 && (
                              <td
                                rowSpan={maxRows}
                                className="border-b break-words px-1 text-sm cursor-pointer"
                              >
                                {entry.purchases?.length > 0 && (
                                  <div className="text-sm flex flex-col">
                                    <div
                                      className="text-center p-0 cursor-pointer capitalize"
                                      title="Check account details"
                                      onClick={() => {
                                        navigate(
                                          "/account-books/ledger-details",
                                          {
                                            state: {
                                              purchaseRegister:
                                                entry.purchases[0],
                                              comeBack:
                                                "/dashboard/purchase-table",
                                            },
                                          }
                                        );
                                      }}
                                    >
                                      <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                        <ContactMarquee
                                          firstName={entry.purchases[0].vendor}
                                          secondName={
                                            entry.purchases[0].cousinName
                                          }
                                        />
                                      </div>
                                      <div className="flex gap-2 justify-center w-32 capitalize">
                                        <ContactMarquee
                                          firstName={
                                            entry.purchases[0].ledgerSubGroup
                                          }
                                          secondName={
                                            entry.purchases[0]
                                              .subGroupNameInHindi
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="p-0 text-gray-600 text-nowrap w-32 overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                      <ContactMarquee
                                        firstName={entry.purchases[0].phone}
                                        secondName={entry.purchases[0].address}
                                      />
                                    </div>
                                         <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(entry.purchases[0].balance.closing_balance).toLocaleString('en-IN')} {entry.purchases[0].balance.closing_balance !== 0 ? `(${entry.purchases[0].balance.closing_balance_type})` :""}
                                    </span>
                                </div>
                                  </div>
                                )}
                              </td>
                            )}

                            <td className="border-b text-center text-sm px-1">
                              {sale && (
                                <>
                                  {sale.quantity > 0 && Number(sale.quantity).toLocaleString(
                                    "en-US",
                                    { maximumFractionDigits: 0 }
                                  )}{" "}
                                  {sale.quantity > 0 && sale.unit} {sale.items?.name || ""} {sale.quantity > 0 && " @ "}
                                  {sale.quantity > 0 && Number(sale.rate).toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}
                                  {sale.quantity > 0 && sale.rate && "/"}
                                  {sale.quantity > 0 && Number(
                                    sale.per_quantity ? sale.per_quantity : 1
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}{" "}
                                  {sale.quantity > 0 && " @ "}
                                  {sale.quantity > 0 &&  Number(sale.total).toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}
                                </>
                              )}
                            </td>

                            <td className="border-b border-e text-center text-sm px-1">
                              {sale && (
                                <>
                                  {Number(sale.paid).toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}{" "}
                                  {sale.paid > 0 &&
                                    sale.paymentType &&
                                    `(${sale.paymentType.name})`}
                                </>
                              )}
                            </td>

                            {showTransportation && (
                              <>
                                <td
                                  className="border-b text-center text-sm px-[2px] cursor-pointer"
                                  title="Check account details"
                                >
                                  {transport && (
                                    <div
                                      onClick={() => {
                                        navigate(
                                          "/account-books/ledger-details",
                                          {
                                            state: {
                                              purchaseRegister: transport,
                                              comeBack:
                                                "/dashboard/purchase-table",
                                            },
                                          }
                                        );
                                      }}
                                    >
                                      <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                        <ContactMarquee
                                          firstName={transport.name}
                                          secondName={transport.cousinName}
                                        />
                                      </div>
                                      <div className="flex gap-2 justify-center w-32 capitalize">
                                        <ContactMarquee
                                          firstName={
                                            transport.ledgerSubGroup
                                          }
                                          secondName={
                                            transport.subGroupNameInHindi
                                          }
                                        />
                                      </div>
                                      <div className="p-0 text-gray-600 w-32 text-nowrap overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                        <ContactMarquee
                                          firstName={transport.phone}
                                          secondName={transport.address}
                                        />
                                      </div>
                                           <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(transport.balance.closing_balance).toLocaleString('en-IN')}{transport.balance.closing_balance !== 0 ? `(${transport.balance.closing_balance_type})` :""}
                                    </span>
                                </div>
                                    </div>
                                  )}
                                </td>

                                <td className="border-b text-center text-sm px-1">
                                  {transport && (
                                    <>
                                      {transport.quantity > 0 && Number(transport.quantity).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}{" "}
                                      {transport.quantity > 0 && transport.unit}{" "}
                                      {transport.quantity > 0 && transport.items?.name || ""} { transport.quantity > 0 && " @ "}
                                      {transport.quantity > 0 && Number(transport.rate).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                      {transport.quantity > 0 && transport.rate && "/"}
                                      {transport.quantity > 0 && Number(
                                        transport.per_quantity
                                          ? transport.per_quantity
                                          : 1
                                      ).toLocaleString("en-US", {
                                        maximumFractionDigits: 0,
                                      })}{" "}
                                      {transport.quantity > 0 && " = "}
                                      {transport.quantity > 0 && Number(transport.total).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </>
                                  )}
                                </td>

                                <td className="border-b border-e text-center text-sm px-1">
                                  {transport && (
                                    <>
                                      {Number(transport.paid).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}{" "}
                                      {transport.paid > 0 &&
                                        transport.paymentType &&
                                        `(${transport.paymentType.name})`}
                                    </>
                                  )}
                                </td>
                              </>
                            )}

                            {showLoading && (
                              <>
                                <td
                                  className="border-b text-center text-sm cursor-pointer"
                                  title="Check account details"
                                >
                                  {load && (
                                    <div
                                      onClick={() => {
                                        navigate(
                                          "/account-books/ledger-details",
                                          {
                                            state: {
                                              purchaseRegister: load,
                                              comeBack:
                                                "/dashboard/purchase-table",
                                            },
                                          }
                                        );
                                      }}
                                    >
                                      <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                        <ContactMarquee
                                          firstName={load.name}
                                          secondName={load.cousinName}
                                        />
                                      </div>
                                      <div className="flex gap-2 justify-center w-32 capitalize">
                                        <ContactMarquee
                                          firstName={load.ledgerSubGroup}
                                          secondName={
                                            load.subGroupNameInHindi
                                          }
                                        />
                                      </div>
                                      <div className="p-0 text-gray-600 w-32 text-nowrap overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                        <ContactMarquee
                                          firstName={load.phone}
                                          secondName={load.address}
                                        />
                                      </div>
                                           <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(load.balance.closing_balance).toLocaleString('en-IN')} {load.balance.closing_balance !== 0 ? `(${load.balance.closing_balance_type})` :""}
                                    </span>
                                </div>
                                    </div>
                                  )}
                                </td>

                                <td className="border-b text-center text-sm px-1">
                                  {load && (
                                    <>
                                      {load.quantity > 0 && Number(load.quantity).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}{" "}
                                      {load.quantity > 0 && load.unit} {load.quantity > 0 && load.items?.name || ""} {load.quantity > 0 && " @  "}
                                      {load.quantity > 0 && Number(load.rate).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                      {load.quantity > 0 && load.rate && "/"}
                                      {load.quantity > 0 && Number(
                                        load.per_quantity
                                          ? load.per_quantity
                                          : 1
                                      ).toLocaleString("en-US", {
                                        maximumFractionDigits: 0,
                                      })}{" "}
                                      {load.quantity > 0 && " = "}
                                      {load.quantity > 0 && Number(load.total).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </>
                                  )}
                                </td>

                                <td className="border-b border-e text-center text-sm px-1">
                                  {load && (
                                    <>
                                      {Number(load.paid).toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}{" "}
                                      {load.paid > 0 &&
                                        load.paymentType &&
                                        `(${load.paymentType.name})`}
                                    </>
                                  )}
                                </td>
                              </>
                            )}

                            {rowIndex === 0 && (
                              <td
                                rowSpan={maxRows}
                                className="border-b text-center align-middle"
                              >
                                <div className="flex justify-center gap-2">
                                  <FaEdit
                                    className="text-gray-700 mt-1 cursor-pointer hover:text-theme-btnBg transition-colors"
                                    onClick={async () => {
                                      await handleCancelEdit();
                                      handleEditEntry(entry);
                                    }}
                                    title="Edit purchase"
                                  />
                                  <RiDeleteBin6Fill
                                    className="text-red-700 mt-1 cursor-pointer hover:text-red-800 transition-colors"
                                    title="Delete purchase"
                                    onClick={() => {
                                      setSelectedPurchase(entry);
                                      setShowDeleteModal(true);
                                    }}
                                  />
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      });
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className='text-sm text-gray-600'>{t("noDataAvailable")}</p>
          ))}

        {showDeleteModal && (
          <DeleteDataModal
            selectedLedger={selectedPurchase}
            handleDeleteModalClose={() => {
              setShowDeleteModal(false);
              setSelectedPurchase(null);
            }}
            handleDeleteLedgerApi={handleDeletePurchaseApi}
            showinputFields={true}
          />
        )}
      </div>
    </div>
  );
}